<template>
  <img
    v-if="imageSrc && showImage"
    class="flex max-h-6 items-center text-2xs"
    :src="imageSrc"
    alt="broker image"
    @error="handleImageError"
  />
  <p
    v-else
    class="text-2xs font-semibold text-neutral-subtle"
  >
    {{ brokerName }}
  </p>
</template>

<script>
import { ref } from 'vue';

export default {
  name: 'BrokerImage',
  props: {
    imageSrc: String,
    brokerName: String,
  },
  setup() {
    const showImage = ref(true);

    const handleImageError = () => {
      if (showImage?.value) {
        showImage.value = false;
      }
    };

    return {
      showImage,
      handleImageError,
    };
  },
};
</script>
